/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ listingName: NonNullable<unknown> }} Linkeventto2Inputs */

const en_linkeventto2 = /** @type {(inputs: Linkeventto2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link this event to ${i?.listingName}`)
};

const de_linkeventto2 = /** @type {(inputs: Linkeventto2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Event mit ${i?.listingName} verknüpfen`)
};

/**
* | output |
* | --- |
* | "Link this event to {listingName}" |
*
* @param {Linkeventto2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const linkeventto2 = /** @type {((inputs: Linkeventto2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linkeventto2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_linkeventto2(inputs)
	return de_linkeventto2(inputs)
});
export { linkeventto2 as "linkEventTo" }